import { AssetType, IPathAndDash, Mimetype } from '../defines';

export enum GeneratedVideoModels {
    SORA = 'sora',
    VEO = 'veo',
}
export enum IMAGE_GENERATION_MODELS_ENUM {
    IMAGE_STABILITY = 'IMAGE_STABILITY',
    IMAGE_NANOBANANA = 'IMAGE_NANOBANANA',
    IMAGE_NANOBANANA_PRO = 'IMAGE_NANOBANANA_PRO',
    IMAGE_IMAGEN4_GENERATE = 'imagen-4.0-generate-001',
    IMAGE_IMAGEN4_ULTRA_GENERATE = 'imagen-4.0-ultra-generate-001',
    IMAGE_IMAGEN4_FAST_GENERATE = 'imagen-4.0-fast-generate-001',
    STABILITY = 'stability',
}
export type GeneratedAssetByType = GeneratedVideoModels | IMAGE_GENERATION_MODELS_ENUM;

export interface IAssetInDTO extends IPathAndDash {
    _id?: string;
    folder: string;
    displayName?: string;
    userEmail: string;
    type?: AssetType;
    mimetype?: Mimetype;
    createdAt: Date;
    generatedBy: GeneratedAssetByType;
}

export interface ILocalAsset extends IAssetInDTO {
    canExtendDuration: boolean;
    isImage: boolean;
}
